export default "__VITE_ASSET__Csnjnf28__"